import Player from '@vimeo/player'
import { useEffect, useRef } from 'react'
import { IconPlayerPlayFilled, IconArrowRight } from '@tabler/icons-react'
import { useUserVideo } from '../../api/hooks/User/useUserVideo'
import { useLearningStore } from '../../store/useLearningStore'
import styles from '../../styles/user/LearningContainer.module.scss'

const LearningVideoStep = () => {
  const { levelId, completeVideo } = useLearningStore()
  const { data: videoData } = useUserVideo({ LEVEL_ID: levelId || 0 })
  const questions = useLearningStore((state) => state.questions)
  const iframeRef = useRef<HTMLIFrameElement | null>(null)
  const videoCompleted = useLearningStore((state) => state.videoCompleted)

  useEffect(() => {
    // 처음 시청 시에만 false로 초기화, Watch Again(이미 완료)이면 유지
    if (!useLearningStore.getState().videoCompleted) {
      useLearningStore.setState({ videoCompleted: false })
    }

    if (!iframeRef.current) return

    const player = new Player(iframeRef.current)

    player.on('loaded', () => {
      player.on('timeupdate', ({ percent }) => {
        if (percent >= 0.9) {
          setTimeout(() => {
            useLearningStore.setState({ videoCompleted: true })
          }, 500)
        }
      })

      player.on('ended', () => {
        setTimeout(() => {
          useLearningStore.setState({ videoCompleted: true })
        }, 500)
      })
    })

    return () => {
      player.unload().catch(() => {})
    }
  }, [videoData])

  if (!videoData?.data?.[0]) {
    return <div className={styles.videoStepWrapper} />
  }

  const videoInfo = videoData.data[0]
  const vimeoId = videoInfo.VIMEO_ID
  const hashkey = videoInfo.HASHKEY
  const title = videoInfo.TITLE
  return (
    <div className={styles.videoStepWrapper}>

      {/* 타이틀 바 + 영상 카드 */}
      <div className={styles.videoCard}>
        <div className={styles.videoTitleBar}>
          <div className={styles.videoTitleIcon}>
            <IconPlayerPlayFilled size={18} />
          </div>
          <div className={styles.videoTitleText}>
            <span className={styles.videoTitleLabel}>Watch Lesson</span>
            {title && <span className={styles.videoTitleSub}>{title}</span>}
          </div>
        </div>

        <div className={styles.videoAspectBox}>
          <iframe
            ref={iframeRef}
            src={`https://player.vimeo.com/video/${vimeoId}?h=${hashkey}&api=1&title=0&byline=0&portrait=0`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={title}
          />
        </div>
      </div>

      {/* What you'll do next 카드 이미지 */}
      <img src="/assets/video-monster.png" alt="What you'll do next" className={styles.videoNextCardImg} />

      {/* Start Questions 버튼 */}
      <button
        className={`${styles.videoStartButton} ${!videoCompleted ? styles.videoStartButtonDisabled : ''}`}
        onClick={videoCompleted ? completeVideo : undefined}
        disabled={!videoCompleted}
      >
        Start Questions <IconArrowRight size={20} />
      </button>

    </div>
  )
}

export default LearningVideoStep
